
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/dynamic-still",
      function () {
        return require("private-next-pages/archive/dynamic-still.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/dynamic-still"])
      });
    }
  